module.exports = require("./qu-EC.js");